import { ComponentProps } from "react";
import { cn } from "@/lib/utils";

// Assets
import CheckCircleSolidSvg from "@assets/icons/check-circle-solid.svg?react";
import PremiumIconSrc from "@assets/icons/premium.png";

const iconDimensions = cn("w-6 h-6");

export function PremiumIcon({ className, ...props }: ComponentProps<"img">) {
  return <img className={cn(iconDimensions, className)} src={PremiumIconSrc} {...props} />;
}

type InUseIconProps = ComponentProps<"svg"> & { active?: boolean };

export const InUseIcon = ({ className, active, ...props }: InUseIconProps) => {
  return (
    <CheckCircleSolidSvg
      {...props}
      className={cn(
        iconDimensions,
        "rounded-full bg-white",
        active ? "text-primary" : "text-primary-light",
        className,
      )}
    />
  );
};
